import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../views/404.vue')
    },
    {
        path: '/mobile-not-supported',
        name: 'MobileNotSupported',
        component: () => import('../views/MobileNotSupported.vue')
    },
    {
        path: '/',
        name: 'Front',
        component: () => import('../components/Front'),
        children: [
            {
                path: 'home',
                name: 'FrontHome',
                component: () => import('../views/Home.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'custom',
                name: 'Custom',
                component: () => import('../views/Custom.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'highlights',
                name: 'Highlights',
                component: () => import('../views/Highlights.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'guide',
                name: 'Guide',
                component: () => import('../views/Guide.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'annual-reports',
                name: 'AnnualReports',
                component: () => import('../views/AnnualReports.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'message',
                name: 'Message',
                component: () => import('../views/Message.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    
    // Helper 相关路由（需要登录）
    {
        path: '/helper',
        component: () => import('../views/Helper.vue'),
        meta: { requiresAuth: true },
        redirect: '/helper/diagram',
        children: [
            {
                path: 'diagram',
                name: 'Diagram',
                component: () => import('../views/Diagram.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'structureChart',
                name: 'StructureChart',
                component: () => import('../views/StructureChart.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'useCaseDiagram',
                name: 'UseCaseDiagram',
                component: () => import('../views/UseCaseDiagram.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'flowchart',
                name: 'Flowchart',
                component: () => import('../views/Flowchart.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'swimlane',
                name: 'Swimlane',
                component: () => import('../views/Swimlane.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sequence',
                name: 'Sequence',
                component: () => import('../views/Sequence.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'taskBook',
                name: 'TaskBook',
                component: () => import('../views/TaskBook.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'articleGenerate',
                name: 'ArticleGenerate',
                component: () => import('../views/ArticleGenerate.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'testCase',
                name: 'TestCase',
                component: () => import('../views/TestCase.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'reduceAigc',
                name: 'ReduceAigc',
                component: () => import('../views/ReduceAigc.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'aigcCheck',
                name: 'AigcCheck',
                component: () => import('../views/AigcCheck.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rechargeHistory',
                name: 'RechargeHistory',
                component: () => import('../views/RechargeHistory.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'messageWall',
                name: 'MessageWall',
                component: () => import('../views/Message.vue'),
                meta: { requiresAuth: true }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

// 重置路由
export const resetRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history',
        routes
    })
}



router.beforeEach((to, from, next) => {
    localStorage.setItem("currentPathName", to.name)
    store.commit("setPath")
    
    // 获取用户信息
    const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    
    // 检查路由是否需要登录
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    
    if (requiresAuth && !user) {
        // 需要登录但未登录
        if (to.path === '/message') {
            // 留言墙页面：跳转到首页并触发登录弹窗
            store.commit('setShowLoginModal', true)
            next('/home')
        } else {
            // 其他需要登录的页面：跳转到首页
            next('/home')
        }
    } else if (!to.matched.length) {
        // 路由不存在
        next("/404")
    } else {
        next()
    }
})

export default router
